import { Stroke, Style } from 'ol/style';

export function selectionBoundingBoxStyle(): Style {
  return new Style({
    stroke: new Stroke({
      color: '#36b8b8',
      width: 2,
    }),
  });
}
